import { z } from 'zod'

import { surveyFilterGroupsSchema } from '~/utils'

export const schema = z.object({
  filterGroups: surveyFilterGroupsSchema,
})
export type InputValues = z.infer<typeof schema>
